import styled from 'styled-components';

const Input = styled.input`
  background: none;
  width: 100%;
  padding: 12px 16px;
  border-radius: 4px;
  border: 2px solid #ddd;
  font-size: 15px;
  color: white;
  height: 55px;
`;

export default Input;
